
import { computed, defineComponent } from "vue";
import useTodo from "@/composables/useTodo";
import TodoFilter from "./shared/TodoFilter.vue";

export default defineComponent({
  name: "TodoFooter",

  components: { TodoFilter },

  setup() {
    const { todos, filteredTodos, filter, clearTodos } = useTodo();

    const items = computed(() =>
      filteredTodos.value.length > 0
        ? filteredTodos.value.length
        : todos.value.length
    );

    return { items, filter, clearTodos };
  }
});
